import { Text, Flex } from '@chakra-ui/react';
import { PageContent } from 'src/components/PageContent';
import { SectionBox } from 'src/components/SectionBox';
import { breadcrumb } from './breadcrumb';

export const ApplicationAppStores = () => {
  return (
    <PageContent title='LOJAS DE APLICATIVO' breadcrumbItems={breadcrumb}>
      <SectionBox bodyProps={{ gap: 'small' }}>
        <Flex direction='column' gap='deka'>
          <Text fontWeight='bold' color='brand.500'>
            Lojas de Aplicativo
          </Text>
        </Flex>
      </SectionBox>
    </PageContent>
  );
};
